export default __webpack_public_path__ + "static/media/Group 1171276194.bdef3c62.svg";